import { articleFields } from "../fragments";

export default `
  ${articleFields}

  query($catalogProductId: [String!], $limit: Int, $offset: Int) {
    similars(catalogProductId: $catalogProductId, limit: $limit, offset: $offset) {
      similars {
        ...articleFields
      }
        pagination{
          total
          limit
          offset
          hasMore
          nextOffset
        }
}
    }
`;